import { useSelector } from 'react-redux';
import { Box, Text } from '@chakra-ui/react';
import { ApplicationState } from '../../../../../store';
import { CustomHeading } from 'shared-components';
import Field from '../../../../Field/Field';
import { PrevNextButtons } from '../../../../PrevNextButtons';
import { useNavigate } from 'react-router-dom';
import ApplicantHeader from '../../../../../components/molecules/applicantHeader';
import { getApplicationData } from '@/components/pages/applicant-dashboard/sections/helpers/getApplicationData';
import { useTaskNavigation } from '@/hooks/useTaskNavigation';
import { useTranslation } from "react-i18next";

export default function PrivacyPolicy() {
    const { t } = useTranslation('common');
  const { application } = useSelector((state: ApplicationState) => state.apply);

  const { initial, current } = getApplicationData(application);
  const { accuracyOfDataConsent } = current;
  const { accuracyOfDataConsent: initialAccuracyOfDataConsent } = initial;

  const AcceptanceText = () => (
    <>
      <Text>
        {t('common:pleaseEnsureTheInformationYouHav')}
                    </Text>
      <Text>
        {t('common:theUniversityWillUseThisInformat')}
                    </Text>
      <Text>
        {t('common:ifAnOfferIsMadeWithAnApplication')}
                    </Text>
    </>
  );

  const RejectionText = () => <Text>{t('common:theApplicantHasNotAgreedToTheAcc')}</Text>;

  const navigate = useNavigate();
  const { nextRoute, previousRoute } = useTaskNavigation();
  return (
    <>
      <ApplicantHeader pageName="Application" />
      <Box>
        <CustomHeading level="h1" flexGrow={1} mb={8}>
          {t('common:accuracyOfData')}
                          </CustomHeading>

        <CustomHeading level="h2" mb={2} mt={6} fontSize="md">
          {t('common:data')}
                          </CustomHeading>

        <Box>
          <Field
            leftLabel="Agreed to"
            value={accuracyOfDataConsent ? <AcceptanceText /> : <RejectionText />}
            originalValue={initialAccuracyOfDataConsent ? <AcceptanceText /> : <RejectionText />}
          />
        </Box>

        <Box mt={6}>
          <PrevNextButtons
            onPrevious={previousRoute ? () => navigate(previousRoute) : undefined}
            onNext={nextRoute ? () => navigate(nextRoute) : undefined}
          />
        </Box>
      </Box>
    </>
  );
}
